import Buttons from "./Buttons";
import ComponentTransition from "./ComponentTransition";
import FaqAccordian from "./FaqAccordian";
import BusinessCreditInfo from "./BusinessCreditInfo"; // Importing BusinessCreditIntro
import React from "react";
import { FaPiedPiper } from "react-icons/fa";

const CardBusinessCreditFaq = () => {
  const faqContent = [
    {
      question: "What is Business Credit?",
      answer:
        "Business credit scores rate your company’s financial health, showing lenders and vendors if your business is reliable with payments. Even if you have great personal credit, a strong business credit score keeps finances separate and opens doors to better loans, lower rates, and trusted partnerships. With Futeur.ai, access your Experian and Equifax business credit scores instantly, helping you make smart decisions and build a solid foundation for growth.",
    },
    {
      question: "Why do I need business credit if I have excellent personal credit?",
      answer:
        "A great personal credit score isn’t enough—your business needs its own score to separate your finances. A strong business credit score means better loans, lower rates, and trusted partnerships, as lenders and vendors often check your business credit, not personal. This builds your company’s financial credibility while keeping your personal credit protected.",
    },
    {
      question: "How is business credit different from FICO Scores?",
      answer:
        "Business credit scores assess a company’s financial health and reliability, helping lenders and vendors decide if a business can handle credit. They consider factors like payment history with suppliers, financials, and public records and usually range from 0-100 (or up to 1,610 in some models) from providers like Experian and Equifax. FICO Scores, on the other hand, focus on an individual’s credit behavior, factoring in personal debt, credit utilization, and payment history on a 300-850 scale, impacting personal loans, mortgages, and credit cards. In essence, business credit scores rate a company, while FICO scores rate a person.",
    },
    {
      question: "How does building my business credit help my company grow?",
      answer:
        "Building strong business credit unlocks more than just financing options. With a good business credit score, your company can qualify for larger loans and credit lines, attract more favorable supplier terms, and secure insurance at better rates. This frees up cash flow, allowing you to invest more in growth without tying up your personal finances. Strong business credit makes scaling your business easier and keeps opportunities within reach.",
    },
    {
      question: "Will checking my business credit hurt my score?",
      answer:
        "No, checking your business credit won’t affect your score. With Futeur.ai, you get regular updates and real-time monitoring of your Experian and Equifax business scores without impacting your credit. This lets you keep an eye on your financial health and act quickly if something needs attention. Monitoring your score is a proactive step that can help you build stronger, more stable business credit.",
    },
    {
      question: "How can I use my business credit score to get better terms with suppliers?",
      answer:
        "A strong business credit score shows suppliers that your company is financially reliable. This credibility can lead to more flexible payment terms, like net-30 or net-60, which means you’ll have a month or two to pay instead of upfront. Better terms with suppliers can improve your cash flow and even lead to discounts, making it easier to keep your business running smoothly. With Futeur.ai, you’re always aware of your score and prepared to leverage it in negotiations with suppliers.",
    },
  ];

  return (
    <div className="py-16 px-6 md:px-10 lg:px-20 flex w-full justify-center flex-wrap relative gap-10">
      {/* Background Glow */}
      <div className="absolute z-[-9] glowbg w-full md:w-[600px] h-[400px] top-[50px] opacity-40"></div>

      {/* Frequently Asked Questions Header */}
      <div className="w-full text-center mb-8">
        <h2 className="text-6xl font-bold text-white dark:text-white">Frequently Asked Questions</h2>
       
      </div>

      {/* FAQ Section */}
      <div className="w-full max-w-3xl" style={{ color: "black" }}>
        <FaqAccordian faqs={faqContent} />
      </div>

      {/* Business Credit Intro Card */}
     {/*  <BusinessCreditInfo /> Replacing the Info Card with BusinessCreditIntro */}
    </div>
  );
};

export default CardBusinessCreditFaq;

